import { Field, Float, Int, ObjectType } from '@nestjs/graphql'

@ObjectType()
export class ReviewStatsDto {
  @Field(t => Int)
  complete!: number

  @Field(t => Int)
  cancelled!: number

  @Field(t => Int)
  pastDue!: number

  @Field(t => Int)
  active!: number

  @Field(t => Float)
  averageRating!: number

  @Field(t => Int)
  reviewCount!: number
}
